
export default {
  getCurrent (state = {}) {
    const {current, tabs = []} = state
    const TabHasCurrentKey = tabs.find(item => {
      return +item.value === +current
    })
    if (TabHasCurrentKey) return +current
    else return 0
  },
  getFilterParams (state) {
    const params = {}
    for (let key in state.filters) {
      if (state.filters[key] !== undefined) {
        params[key] = state.filters[key]
      }
    }
    return params
  }
}
